/**
 * OS SISTEMAS DA SUÍTE — a lista que aparece em todo seletor deste app.
 *
 * O `id` é o mesmo que o Portal usa em três lugares que precisam bater: a
 * coluna `sistemas` do usuário (controle de acesso), o `sistema` gravado na
 * auditoria central e o `sistema_alvo` do aviso que vira faixa dentro do
 * sistema. Um id diferente aqui faria o aviso de atualização não aparecer em
 * lugar nenhum — sem erro, só silêncio.
 */
import { ordenarPorNome } from "./ordem";

export interface SistemaInfo {
  id: string;
  nome: string;
}

export const SISTEMAS: SistemaInfo[] = [
  { id: "portal", nome: "Portal SERCAMP" },
  { id: "rh", nome: "Recursos Humanos" },
  { id: "dp", nome: "Departamento Pessoal" },
  { id: "qualidade", nome: "Qualidade" },
  { id: "almoxarifado", nome: "Almoxarifado" },
  { id: "planejamento", nome: "Planejamento" },
  { id: "operacional", nome: "Gestão da Operação" },
  { id: "comercial", nome: "Comercial (SDR)" },
  { id: "proposta", nome: "Propostas" },
  // Área /gestao do app do Propostas, com card e acesso próprios no Portal.
  { id: "gestao_comercial", nome: "Gestão Comercial" },
  { id: "relatorios", nome: "Relatórios" },
  { id: "laboratorio", nome: "Laboratório" },
  { id: "colaborador", nome: "Operacional (colaborador)" },
  { id: "suprimentos", nome: "Suprimentos" },
  // O sistema do ponto (4014): o id interno segue "ponto"; o nome visível é Colaboradores.
  { id: "ponto", nome: "Colaboradores" },
  { id: "desenvolvedor", nome: "Desenvolvimento" },
];

/**
 * A mesma lista em ordem alfabética pelo nome — é esta que os SELETORES
 * mostram (padrão da suíte, igual à agenda do Planejamento). Cópia: o
 * SISTEMAS acima continua como está para as buscas por id.
 */
export const SISTEMAS_EM_ORDEM: SistemaInfo[] = ordenarPorNome(SISTEMAS, (s) => s.nome);

/** Nome de exibição de um id (o próprio id quando for algo que não conhecemos). */
export function nomeDoSistema(id: string | null | undefined): string {
  const alvo = String(id ?? "").trim();
  if (!alvo) return "Geral";
  return SISTEMAS.find((s) => s.id === alvo)?.nome ?? alvo;
}
